import React, { useEffect, useState, useContext } from "react";
import moment from "moment";
import { Button, Modal, Row, Col, Radio, Form, Input, Checkbox } from 'antd';
import ifailed from './../../../assets/pvi-benhhiemngheo/ifailed.png';
import { AuthContext } from './../index';

const ModalSelect = (props) => {
  const { goStep, dataRenewals, listIsu, ActionList } = useContext(AuthContext);
  const [openUpdate, setOpenUpdate] = useState(false);


  const css = {
    input: { color: '#3A3A3A', zIndex: 1, fontSize: 15, boxShadow: 'none', padding: '10px 35px', borderRadius: 9, width: '100%' },
    titleInput: { color: '#646D69', marginBottom: 3 },
    FormItemsHolder: { width: "100%", borderRadius: 8, margin: '5px 0px', padding: 0 },
    iconInput: { width: 20, margin: '14px 10px', position: 'absolute', zIndex: 2 }
  }

  const Renewals = () => {
    props.ConfirmRene('yes');
    let dataIsu = JSON.parse(localStorage.getItem('dataIsu'));
    setTimeout(() => {
      localStorage.setItem('dataIsu',
        JSON.stringify({
          ...dataIsu,
          beginDate: dataRenewals?.result?.beginDate,
          endDate: moment(new Date(dataRenewals?.result?.beginDate.replace(/(\d+[/])(\d+[/])/, "$2$1"))).subtract(1,"days").add(1, "years").format("DD/MM/YYYY")
        })
      )
    }, 100);
  }

  return (
    <div style={{ fontSize: 16 }}>
      <Modal
        centered={true}
        footer={false}
        closable={true}
        open={props.isModalVisible}
        onCancel={props.handleCancel}
        maskStyle={{background:'#000000',opacity:0.8}}
      >
        <div >
          <div style={{ textAlign: 'center' }}>
            <img src={ifailed} alt="home" width="100px" height="auto" />
            <div>
              <div style={{ marginTop: 0, fontWeight: 600, fontSize: 18 }}>Thông báo tái tục</div>
              <div style={{ marginTop: 10, fontSize: 14 }}>
                Người được bảo hiểm này cần được tái tục liên tục. Chúng tôi sẽ tự động lấy ngày hiệu lực liên tiếp với ngày hiệu lực trước đó để làm thời hạn bảo hiểm cho đơn này. Bạn có muốn tiếp tục không ?
              </div>
              <div style={{ marginTop: 10, fontSize: 14, color: 'red' }}>
                Lưu ý: Nếu từ chối vui lòng đổi người được bảo hiểm khác.
              </div>
            </div>
            <div style={{ textAlign: 'center', marginTop: 15, display: 'flex', justifyContent: 'space-between' }}>
              <Button onClick={() => props.handleCancel()} style={{ width: '47%', fontSize: 14, border: '1px solid #2A3790', borderRadius: 100, fontWeight: 'bold', color: '#2A3790', height: 40 }} color="#ED5A33">
                Từ chối
              </Button>
              <Button onClick={() => Renewals()} style={{ width: '47%', fontSize: 14, background: '#2A3790', borderRadius: 100, fontWeight: 'bold', color: '#ffffff', height: 40 }} color="#ED5A33">
                Đồng ý
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div >
  );
};

export default ModalSelect;